/** Coerce to number and verify it is finite; throws on bad input. */
export function safeNum(value: unknown): number {
  const n = Number(value);
  if (!isFinite(n)) {
    throw new Error(`Expected finite number, got: ${value}`);
  }
  return n;
}

export function emptyFC(): GeoJSON.FeatureCollection {
  return { type: "FeatureCollection", features: [] };
}

export function lineFC(coordinates: number[][], properties: GeoJSON.GeoJsonProperties = {}): GeoJSON.FeatureCollection {
  return {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties,
        geometry: { type: "LineString", coordinates },
      },
    ],
  };
}
